import { Fragment } from "react";
import { BadgeCheck } from "lucide-react";
import { EDITORIAL_FEATURES, SYNDICATED_COVERAGE } from "@/lib/mediaCoverage";

const OUTLETS = [...EDITORIAL_FEATURES, SYNDICATED_COVERAGE[0]];

export const TrustLine = () => (
  <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 pt-4 text-xs" data-testid="home-trust-line">
    <BadgeCheck size={14} style={{ color: "var(--gold)" }} />
    <span className="uppercase tracking-[0.22em] text-white/45 text-[10px]">Featured on</span>
    {OUTLETS.map((o, i) => (
      <Fragment key={o.id}>
        {i > 0 && <span aria-hidden="true" className="text-white/25">·</span>}
        <a
          href={o.url}
          target="_blank"
          rel="noopener noreferrer"
          className="font-serif text-sm text-white/70 hover:text-[color:var(--gold)] transition-colors whitespace-nowrap"
          data-testid={`trust-line-${o.id}`}
        >
          {o.outlet}
        </a>
      </Fragment>
    ))}
  </div>
);
